import React from 'react';
import { Settings, Phone, Mail, MapPin, Save } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const SiteTab = ({ siteSettings, onSiteChange, onSave, saving }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Settings className="h-5 w-5" /> Site Configuration
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">
            <Phone className="inline h-4 w-4 mr-1" /> Contact Phone
          </label>
          <Input name="contact_phone" value={siteSettings.contact_phone} onChange={onSiteChange} placeholder="+2348012345678" data-testid="contact-phone" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            <Mail className="inline h-4 w-4 mr-1" /> Contact Email
          </label>
          <Input name="contact_email" value={siteSettings.contact_email} onChange={onSiteChange} placeholder="sale@dayefarmltd.com" data-testid="contact-email" />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium mb-1">
            <MapPin className="inline h-4 w-4 mr-1" /> Address
          </label>
          <Input name="address" value={siteSettings.address} onChange={onSiteChange} placeholder="123 Farm Road, Lagos, Nigeria" data-testid="address" />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium mb-1">
            <MapPin className="inline h-4 w-4 mr-1" /> Google Maps Embed URL
          </label>
          <Input name="map_embed_url" value={siteSettings.map_embed_url} onChange={onSiteChange} placeholder="https://www.google.com/maps/embed?..." data-testid="map-embed-url" />
          <p className="text-xs text-gray-500 mt-1">Get embed URL from Google Maps - Share - Embed a map</p>
        </div>
      </div>

      <Button onClick={onSave} disabled={saving}>
        <Save className="h-4 w-4 mr-2" /> {saving ? 'Saving...' : 'Save Site Settings'}
      </Button>
    </CardContent>
  </Card>
);

export default SiteTab;
